import { render, staticRenderFns } from "./TransportCarrier.vue?vue&type=template&id=4b95e342"
import script from "./TransportCarrier.vue?vue&type=script&lang=js"
export * from "./TransportCarrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports